import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Datetime from "react-datetime";
import ButtonGroupSelect from '../../components/Select/ButtonGroupSelect';
import Success from '../../components/Typography/Success';
import Slider from '../../components/Slider/Slider';
import { FormControl, InputLabel } from '@material-ui/core';
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { OrdinalSuffixOf } from '../../helpers/RandomHelpers';
import moment from 'moment';

const once_off = "once off";
const daily = "daily";
const weekly = "weekly";
const monthly = "monthly";

const weekly_options = [
    {
        name: "mon",
        value: 1,
        display: "Monday"
    },
    {
        name: "tue",
        value: 2,
        display: "Tuesday"
    },
    {
        name: "wed",
        value: 3,
        display: "Wednesday"
    },
    {
        name: "thu",
        value: 4,
        display: "Thursday"
    },
    {
        name: "fri",
        value: 5,
        display: "Friday"
    },
    {
        name: "sat",
        value: 6,
        display: "Saturday"
    },
    {
        name: "sun",
        value: 7,
        display: "Sunday"
    }
]

class ScheduleManager extends React.Component {

    state = {
        period: once_off,
        daily: 0,
        weekly: '',
        monthly: '',

        weeklyDays: ["mon"],

        monthlySliderDisplay: 1,
        monthlySlider: 1,

        time: moment().startOf('day')
    }

    getSchedule() {
        switch (this.state.period) {
            case once_off:
                return null;
            case daily:
                return {
                    daily: 1,
                    runtime: this.state.time.format("HH:mm:ss")
                }
            case weekly:
                return {
                    weekly: this.state.weeklyDays.map((x, i, arr) => weekly_options.find(w => w.name === x).value).join(","),
                    runtime: this.state.time.format("HH:mm:ss")
                }
            case monthly:
                return {
                    monthly: this.state.monthlySlider,
                    runtime: this.state.time.format("HH:mm:ss")
                }
        }
    }

    scheduledDescription() {
        switch (this.state.period) {
            case once_off:
                return "only once, immediately."
            case daily:
                return "everyday at " + this.state.time.format("HH:mm") + "."
            case weekly:
                return `on ${
                    this.state.weeklyDays.map((x, i, arr) => {
                        var option = weekly_options.find(w => w.name === x);
                        if (i < arr.length - 1) {
                            return option.display + (i === arr.length - 2 ? " " : ", ")
                        } else if (arr.length !== 1) {
                            return "and " + option.display;
                        } else {
                            return option.display;
                        }
                    }).join("")
                    } of each week at ${this.state.time.format("HH:mm")}.`
            case monthly:
                if (this.state.monthlySlider === 0)
                    return "never.";
                else if (this.state.monthlySlider > 0)
                    return `every month on the ${OrdinalSuffixOf(this.state.monthlySlider)} at ${this.state.time.format("HH:mm")}`;
                else
                    return `every month, ${Math.abs(this.state.monthlySlider)} day${this.state.monthlySlider === -1 ? "" : "s"} before the 1st at ${this.state.time.format("HH:mm")}`;
        }
    }

    renderSpecifics() {
        switch (this.state.period) {
            case once_off:
                return null;
            case daily:
                return null;
            case weekly:
                return [
                    <br key="break" />,
                    <ButtonGroupSelect
                        key="btngrp"
                        options={weekly_options.map(x => x.name)}
                        value={this.state.weeklyDays}
                        onChange={(val) => {
                            this.setState({ weeklyDays: val })
                        }}
                        isMulti
                    />
                ]
            case monthly:
                return (
                    <div>
                        <h3 style={{ textAlign: 'center' }}><span style={{ border: '1px solid rgba(0,0,0,0.24)', borderRadius: 3, padding: '10px 14px' }}>{this.state.monthlySliderDisplay}</span></h3><br />
                        <Slider
                            range={[-31, 31]}
                            onUpdate={(value) => this.setState({ monthlySliderDisplay: value === 0 ? "Never" : (value > 0 ? OrdinalSuffixOf(value) : value) })}
                            onSet={(value) => this.setState({ monthlySlider: value })}
                            value={this.state.monthlySlider}
                        />
                    </div>
                ); //TODO: Add Slider
        }
    }

    render() {

        //const { classes } = this.props;

        return (
            <div style={{ textAlign: 'center' }}>
                <Success>
                    {`Report will run ${this.scheduledDescription()}`}
                </Success>

                <ButtonGroupSelect
                    options={[once_off, daily, weekly, monthly]}
                    value={this.state.period}
                    onChange={(val) => this.setState({ period: val })}
                />

                {this.renderSpecifics()}

                {
                    this.state.period !== once_off ?
                        <FormControl fullWidth>
                            <InputLabel
                                htmlFor="run_at"
                                style={{
                                    top: -8,
                                    color: '#AAAAAA !important',
                                    fontSize: 14,
                                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                    fontWeight: 400,
                                    lineHeight: 1.42857
                                }}
                                shrink
                            >
                                Run at</InputLabel>
                            <Datetime
                                id="run_at"
                                dateFormat={false}
                                inputProps={{ placeholder: "Run at", style: { fontSize: '1.5em' }, id: 'run_at' }}
                                timeFormat={"HH:mm"}
                                timeConstraints={{ minutes: { step: 5 } }}
                                value={this.state.time}
                                onChange={(val) => this.setState({ time: val })}
                            />
                        </FormControl>
                        :
                        null
                }

                {/* TODO: */}

                {/* Start Date Variable */}

                {/* End Date Variable */}

            </div>
        );
    }
}

export default withStyles(extendedFormsStyle)(ScheduleManager);